import $ from 'jquery';
import { bind } from '@ember/runloop';
export default function (url) {
  return new Promise(function (resolve, reject) {
    let video = document.createElement('video');
    let $video = $(video);
    $video.on('loadeddata', bind(this, function () {
      resolve(video.duration);
      $video.off('loadeddata');
    }));
    $video.on('error', bind(this, function () {
      reject('Failed to load video file');
      $video.off('loadeddata');
    }));
    video.src = url;
  });
}